import { inject } from "@angular/core";
import { RedirectCommand, ResolveFn, Router } from "@angular/router";

import { NavbarService } from "../navbar.service";
import { toInteractiveTypedId } from "../../../interactives/mappers/interactives-list.mapper";

// Data flows through NavbarService — this resolver only validates the ID and redirects if needed.
export const interactivesResolver: ResolveFn<undefined> = route => {
    const router = inject(Router);
    const navbarService = inject(NavbarService);
    const interactiveId = route.paramMap.get("interactiveId") ?? "";

    const allInteractives = navbarService.allInteractives();

    if (allInteractives.some(i => i.id === interactiveId)) return undefined;

    const view = route.parent?.routeConfig?.path;

    if (!allInteractives.length) {
        return new RedirectCommand(router.createUrlTree(["interactives", view]), { replaceUrl: true }) as never;
    }

    return new RedirectCommand(router.createUrlTree(["interactives", view, toInteractiveTypedId(allInteractives[0])]), {
        replaceUrl: true
    }) as never;
};
